import { toNumericImportId } from "../../../utils/importIdUtils";

export const getNextImportProfile = (profiles = [], currentId) => {
    const list = Array.isArray(profiles) ? profiles : [];
    const index = list.findIndex((profile) => String(profile.id) === String(currentId));
    if (index < 0 || index === list.length - 1) return null;
    return list[index + 1];
};

export const buildFiscalYearOptions = (projectFiscalYears = {}, urlFiscalYear) => {
    const years = new Set(
        Object.keys(projectFiscalYears || {}).filter((year) => /^\d{4}$/.test(year)),
    );
    if (/^\d{4}$/.test(String(urlFiscalYear || ""))) {
        years.add(String(urlFiscalYear));
    }
    return Array.from(years).sort((a, b) => Number(b) - Number(a));
};

export const getSuggestedFiscalYear = (options = [], urlFiscalYear, hasAiSuggestions) => {
    if (hasAiSuggestions) {
        return options[0] || "";
    }
    if (/^\d{4}$/.test(String(urlFiscalYear || ""))) {
        return String(urlFiscalYear);
    }
    return options[0] || "";
};

export const resolveProceedImportId = (yearImportIds) => {
    const firstId = Array.isArray(yearImportIds) ? yearImportIds[0]?.id : undefined;
    return toNumericImportId(firstId);
};
